import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const presencesAdapter = createEntityAdapter({
    sortComparer: (a, b) => (a.completed === b.completed) ? 0 : a.completed ? 1 : -1
})

const initialState = presencesAdapter.getInitialState()

export const presencesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getPresences: builder.query({
            query: () => ({
                url: '/api/presences',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            providesTags: (result, error, arg) => {
                return [{ type: 'Presence', id: 'LIST' }]
            }
          
        }),
        updatePresence: builder.mutation({
            query: initialPresence => ({
                url: '/api/presences',
                method: 'PATCH',
                body: {
                    ...initialPresence,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Presence', id: "LIST" }
            ]
        }),
        updatePresenceByAdmin: builder.mutation({
            query: initialPresence => ({
                url: '/api/presences/byAdmin',
                method: 'PATCH',
                body: {
                    ...initialPresence,
                }
            }),
            invalidatesTags: (result, error, arg) =>{
                return[                  
                    { type: 'Lesson', id: arg.lessonId }
                ]  
            }          
        }),
        updateAllPresenceByAdmin: builder.mutation({
            query: ({lessonId, reason}) => ({
                url: `/api/presences/updatePrecent/${lessonId}`,
                method: 'PATCH',
                body: {
                    reason,
                }
            }),
            invalidatesTags: (result, error, arg) =>{
                return[                  
                    { type: 'Lesson', id: arg.lessonId }
                ]  
            }          
        }),

    }),
})

export const {
    useGetPresencesQuery,
    useUpdatePresenceMutation,
    useUpdatePresenceByAdminMutation,
    useUpdateAllPresenceByAdminMutation
} = presencesApiSlice

// returns the query result object
export const selectPresencesResult = presencesApiSlice.endpoints.getPresences.select()

// creates memoized selector
const selectPresencesData = createSelector(
    selectPresencesResult,
    presencesResult => presencesResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllPresences,
    selectById: selectPresenceById,
    selectIds: selectPresenceIds
    // Pass in a selector that returns the presences slice of state
} = presencesAdapter.getSelectors(state => selectPresencesData(state) ?? initialState)